import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import allRoutes from '../../views/Protected/Admin/adminRoutes'
import useRules from '../../hooks/useRules'
import {useHistory} from "react-router-dom"

const AdminSidebar = ({onClose}) => {
  const [rules,hasRule,isAdmin] = useRules();
  const history = useHistory()
  const routes = allRoutes.filter(route=>hasRule(route.slug) || route.slug==='sidemenu_password')

  const handleClick = (path)=>{
    history.push(`/protected/admin${path}`)
    onClose();
  }

  return (
    <List>
      {routes?.map(route=><ListItem button key={route.slug} onClick={()=>handleClick(route.path)}>
        <ListItemIcon>{route.icon}</ListItemIcon>
        <ListItemText primary={route.name} />
      </ListItem>)}
    </List>
  )
}

export default React.memo(AdminSidebar)
